<template>
  <div>
    <h2>Search for an address</h2>
    <p>
      Enter the search term to find. The search term can be a postcode, company
      name or street and town (separated by commas).
    </p>
    <v-text-field label="Search for address" v-model="searchTerm" outline />
    <v-btn
      @click="find"
      :disabled="postcodeSearchLoading"
      :loading="postcodeSearchLoading"
    >
      <v-icon>search</v-icon>Search
    </v-btn>
    <v-data-table
      v-if="v110results && v110results.length > 0"
      :headers="headers"
      :items="v110results"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              @click="changeAddress(props.item)"
              :disabled="v110result"
              :loading="v110result"
              >{{
                props.item.Type === "Address"
                  ? props.item.Id.substring(props.item.Id.lastIndexOf("|") + 1)
                  : "Select"
              }}</v-btn
            >
          </td>
          <td>{{ props.item.Text }}</td>
          <td>{{ props.item.Description }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-alert
      v-if="v110results && v110results.length == 0"
      :value="true"
      type="info"
      >No results found</v-alert
    >
    <!-- <v-progress-circular indeterminate color="info" v-if="!v110results" /> -->
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="3000"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import SEARCH_POSTCODE from "@/graphql/directory/SearchPostcode";
function initialState() {
  return {
    searchTerm: null,
    postcodeSearchLoading: false,
    headers: [
      {
        text: "Id",
        value: "Id"
      },
      {
        text: "Text",
        value: "Text"
      },
      {
        text: "Description",
        value: "Description"
      }
    ],
    v110results: null,
    v110result: false,
    snackbar: false,
    snackbarText: null
  };
}
export default {
  name: "Postcode",
  data: function () {
    return initialState();
  },
  methods: {
    async find() {
      if (this.searchTerm) {
        this.postcodeSearchLoading = true;
        await this.fetchResults(this.searchTerm);
        this.postcodeSearchLoading = false;
      } else {
        this.snackbar = true;
        this.snackbarText = "Search term empty";
      }
    },
    changeAddress(item) {
      if (item.Type === "Address") {
        this.v110result = true;
        this.$emit("changeAddress", item.Id);
      } else {
        this.fetchResults(this.searchTerm, item.Id);
      }
    },
    async fetchResults(text, container) {
      const variables = {
        text,
        container
      };
      const response = await this.$apollo.query({
        query: SEARCH_POSTCODE,
        variables,
        fetchPolicy: "no-cache"
      });
      this.v110results = response.data.searchPostcode;
    }
  }
};
</script>

<style scoped>
</style>